import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  for: "firstname",
  class: "form-label"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, onMounted, watch } from "vue";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneField',
  props: {
  modelValue: {
    type: [String],
    default: "",
  },
  label: { type: String },
  type: { type: String },
  v: {
    type: Object,
  },
},
  emits: ["update:modelValue", "validNumber"],
  setup(__props, { emit }) {

const props = __props;



const results = ref();
const updateModel = (state) => {
  emit("update:modelValue", state);
  emit("validNumber", results.value.isValid);
};

watch(results, () => {
  emit("validNumber", results.value.isValid);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t(__props.label)), 1),
    _createVNode(_unref(MazPhoneNumberInput), {
      color: "info",
      onUpdate: _cache[0] || (_cache[0] = ($event: any) => (results.value = $event)),
      success: results.value?.isValid,
      defaultPhoneNumber: __props.modelValue,
      modelValue: __props.modelValue,
      contenteditable: __props.modelValue,
      "onUpdate:modelValue": updateModel,
      size: "sm",
      "default-country-code": "FR"
    }, null, 8, ["success", "defaultPhoneNumber", "modelValue", "contenteditable"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text-danger",
        key: error.$uid
      }, [
        _createTextVNode(" - " + _toDisplayString(error.$message), 1),
        _hoisted_3
      ]))
    }), 128))
  ]))
}
}

})